var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseFieldWrapper',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(ref){
var vuelidateIns = ref.vuelidateIns;
var value = ref.value;
var listeners = ref.listeners;
var ske = ref.ske;
var attrs = ref.attrs;
return [_vm._t("default"),_c('input',_vm._g(_vm._b({ref:"input",staticClass:"form-control",class:[vuelidateIns && 'border-danger', _vm.warning && 'border-warning'],attrs:{"autocomplete":_vm.autocomplete},domProps:{"value":value}},'input',attrs,false),listeners)),_vm._t("after")]}}],null,true)},'BaseFieldWrapper',Object.assign({}, _vm.$props, _vm.$attrs),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }